import React, { useState } from "react";
import { ISkillLevel } from "../../model/SkillLevel.model";
import useFetchWithMsal from "../../hooks/useFetchWithMsal";
import { protectedResources } from "../../authConfig";
import Modal from "../Modal/Modal";
import "./EditSkillLevelsComponent.scss";

const EditSkillLevelsComponent: React.FC<{
  skillPathId: number;
  skillLevels: ISkillLevel[];
  updateSkillLevelData(event: ISkillLevel[]): void;
}> = (props: {
  skillPathId: number;
  skillLevels: ISkillLevel[];
  updateSkillLevelData(event: ISkillLevel[]): void;
}) => {
    const [editingSL, setEditingSL]: [ISkillLevel | null, any] = useState(null);
    const [maxIndex, setMaxIndex] = useState(0);
    const { error, execute } = useFetchWithMsal({
      scopes: protectedResources.apiCFSkillPath.scopes.write,
    });
    const [loading, setLoading] = useState(true);
    const [callErr, setErr] = useState(null);
    const generateMaxIndex = () => {
      let i = props.skillLevels.reduce((v, sl) => { if (sl.indexNumber > v) return sl.indexNumber; return v; }, 0);
      if (i !== maxIndex) setMaxIndex(i);
    }
    //setName(Skill.SkillName);
    const HandleSubmit = (event: any) => {
      event.preventDefault();
      const formData = new FormData(event.target);
      const inputSN = formData.get("skillLevelName");
      const now = (new Date()).toISOString();
      var nSkillLevel = {
        skillPathId: props.skillPathId,
        skillLevelName: inputSN,
        skillLevelSubtitle: formData.get("skillLevelSubtitle"),
        indexNumber: maxIndex + 1,
        createdDate: now,
        CreatedBy: "me",
        lastModifiedDate: now,
        lastModifiedBy: "me",
      };
      execute("POST", `/api/SkillLevel/addSkillLevel`, nSkillLevel)
        .then((response: any) => {
          //console.log('api call success');
          props.skillLevels.push(response);
          //setLevels(SkillLevels);
          props.updateSkillLevelData(response);
          setLoading(false);
          generateMaxIndex();
        }).catch((err: any) => {
          setErr(err);
          setLoading(false);
        })
      //if (inputSN) Skill.skillName = inputSN + "";
      //props.updateSkillLevelData(Skill);
    };
    const StartEditing = (event: any) => {
      var id: string = event.currentTarget.name.split(':')[1];
      var sl = props.skillLevels.find(x => x.skillLevelId === id);
      if (!sl) return;
      setEditingSL(sl);
    }
    const cancelEdit = (event: any = null) => {
      setEditingSL(null);
    }
    const HandleUpdate = (event: any) => {
      event.preventDefault();
      if (!editingSL) return;
      const formData = new FormData(event.target);
      const now = (new Date()).toISOString();
      const inputSN = formData.get("skillLevelName");
      (editingSL as any).skillLevelName = inputSN;
      (editingSL as any).skillLevelSubtitle = formData.get("skillLevelSubtitle");
      (editingSL as any).lastModifiedDate = now;
      execute("PUT", `/api/SkillLevel/updateSkillLevel`, editingSL)
        .then((response: any) => {
          //console.log('api call success');
          //props.skillLevels.push(response);
          //setLevels(SkillLevels);
          props.updateSkillLevelData(props.skillLevels);
          setLoading(false);
          setEditingSL(null);
        }).catch((err: any) => {
          setErr(err);
          setLoading(false);
          setEditingSL(null);
        })
    }
    generateMaxIndex();
    return (
      <>
        {" "}
        <div className="aln-center">

          <ul className='reset dis-flex dis-flex-jst-center dis-flex-rows gap-3'>
            {props.skillLevels.map((sl: ISkillLevel, index: number) => (
              <li className="aln-center" key={sl.skillLevelId + "-" + index}>
                <h4 className="fnt-wght-700 ltr-spcng-normal m-b--50 m-t-0 clr-primary">{sl.skillLevelName}</h4>
                <button className="btn-secondary" name={'skillLevel:' + sl.skillLevelId} onClick={StartEditing}>Edit</button>
              </li>
            ))}
          </ul>
        </div>
        {editingSL !== null && (<>
          <Modal isOpen={editingSL !== null} hasCloseBtn={true} onClose={cancelEdit} modalTitle="Edit Skill Level">
            <form onSubmit={HandleUpdate} className="modal-form">
              <div className="modal-form-content-scroll-container">
                <div className="form-group m-b-1">
                  <label htmlFor="skillLevelName">Name</label>
                  <input type="text" id="skillLevelName" name="skillLevelName" maxLength={100} defaultValue={(editingSL as ISkillLevel).skillLevelName} required />
                </div>
                <div className="form-group">
                  <label htmlFor="skillLevelSubtitle">Subtitle</label>
                  <input type="text" id="skillLevelSubtitle" name="skillLevelSubtitle" maxLength={300} defaultValue={(editingSL as ISkillLevel).skillLevelSubtitle} />
                </div>
              </div>
              <div className="modal-form-button-container two-button">
                <button type="button" className="btn-med-gray">Delete</button>
                <button type="submit" className="btn-secondary">Update</button>
              </div>
            </form>

          </Modal>
        </>)}
        {props.skillLevels.length < 3 &&
          <form onSubmit={HandleSubmit}>
            <p>
              <input type="text" name="skillLevelName" maxLength={100} required />
            </p>
            <p><input type="text" name="skillLevelSubtitle" maxLength={300} /></p>
            <button type="submit">Add Skill Level</button>
          </form>}
      </>
    );
  };
export default EditSkillLevelsComponent;
